import gql from 'graphql-tag';

export const UPLOAD = gql`
  mutation Upload($file: Upload!, $folder: FolderType) {
    upload(file: $file, folder: $folder) {
      link
    }
  }
`;
